import isEmpty from './isEmpty'
//----------------------------------------------
// convert default skills (to character skills)
//----------------------------------------------
export default function convertDefaultSkills(default_skills) {
  console.log('-----------------------')
  console.log('IN convertDefaultSkills')

  if (isEmpty(default_skills)) {
    return null
  }

  // need attrib as name as this is what is returned from character/skill api
  
  let skills = default_skills.map((s) => {
    const { name, ...rest } = s
    return { ...rest,
      name: name,
      base: 0,
      ticks: 0,
      training: 0,
      adjs_tot: 0,
      cur: 0,
      unadj_cur: 0,
      max: 0,
    }
  })

  return skills
}
